module.exports = "<span class=\"copyrights\">© Runple, {{currentYear}}. All rights reserved.</span>\n"